import React from 'react';
import 'keen-slider/keen-slider.min.css';

interface IDiagramSlide {
    children: React.ReactNode;
}

export const DiagramSlide = ({ children }: IDiagramSlide) => {
    return <div className="keen-slider__slide">{children}</div>;
};
